module.exports = __webpack_public_path__ + "media/images/countrysquared/ec-91973d9d6ebf0ca5e2ed1adebc80b896.svg";